import { useCallback, useEffect, useState } from "react";
import { toast } from "sonner";
import { Mail, RefreshCw } from "lucide-react";
import { Button } from "@/components/ui/button";
import { api, formatError } from "@/lib/api";

export const RosterEmailStatus = ({ start, refreshKey }) => {
  const [rows, setRows] = useState([]);
  const load = useCallback(() => api.get("/roster/email-status", { params: { start } }).then((r) => setRows(r.data)).catch(() => setRows([])), [start]);
  useEffect(() => { load(); }, [load, refreshKey]);
  const sending = rows.some((r) => r.status === "sending" && Date.now() - new Date(r.at).getTime() <= 180000);
  useEffect(() => {
    if (!sending) return undefined;
    const t = setInterval(load, 4000);
    return () => clearInterval(t);
  }, [sending, load]);
  if (!rows.length) return null;
  const n = (s) => rows.filter((r) => r.status === s && !(s === "sending" && Date.now() - new Date(r.at).getTime() > 180000)).length;
  const stuck = (r) => r.status === "sending" && Date.now() - new Date(r.at).getTime() > 180000;
  const failed = rows.filter((r) => r.status === "failed" || stuck(r));
  const resend = async () => {
    try { const { data } = await api.post("/roster/resend-emails", { start }); toast.success(`Resending ${data.resending} roster email${data.resending === 1 ? "" : "s"}`); load(); } catch (e) { toast.error(formatError(e)); }
  };
  return (
    <div className={`mb-4 flex flex-col gap-2 rounded-2xl border p-3 text-sm sm:flex-row sm:items-center sm:justify-between ${failed.length ? "border-red-200 bg-red-50" : "border-slate-200 bg-white"}`} data-testid="roster-email-status">
      <p className="flex items-start gap-2"><Mail className="mt-0.5 h-4 w-4 shrink-0 text-[#00A85C]" />
        <span>Roster emails: <b data-testid="roster-email-sent">{n("sent")} delivered</b>{n("sending") > 0 && <> · <b>{n("sending")} sending…</b></>}{failed.length > 0 && <> · <b className="text-red-700" data-testid="roster-email-failed">{failed.length} not delivered</b> ({failed.map((f) => f.name).join(", ")})</>}</span>
      </p>
      {failed.length > 0 && <Button size="sm" onClick={resend} className="rounded-full bg-[#0B2D5B]" data-testid="roster-email-resend"><RefreshCw className="mr-1 h-4 w-4" />Resend</Button>}
    </div>
  );
};
